import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/GI-splash-comp.jpg'
import _imports_1 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a293e968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth app-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "splash-comp"
}, null, -1))
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Card, { class: "auth-card" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: { name: 'landing' } }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ]))
}